import React from 'react'
import Icon from 'common/components/Icon'
import Text from 'common/components/Text'
import CrashButton from '../../common/CrashButton'
import { useTranslation } from 'react-i18next'
import styled from 'react-emotion'
import { border, z } from '../../../style'
import Overlay from 'common/components/Overlay'
import { RowButton } from 'common/components/Row'

export const UserMenu = styled(
  ({ className, user, plan, logout, hide, menuRef }) => {
    const { t } = useTranslation()
    return (
      <Overlay z={z.sidebarAccountMenu}>
        <div className={className} onClick={hide} ref={menuRef}>
          <RowButton top>
            <Icon icon="arrowhead-up" />
            <Text medium>{user && user.displayName}</Text>
          </RowButton>
          <RowButton to="/settings">
            <Icon icon="none" />
            <Text>{t('sidebar.settings')}</Text>
          </RowButton>
          <RowButton href="mailto:hello@wiip.co">
            <Icon icon="none" />
            <Text>{t('sidebar.support')}</Text>
          </RowButton>
          <RowButton to="/videos/research">
            <Icon icon="none" />
            <Text medium>{t('sidebar.examples')}</Text>
          </RowButton>
          {!plan && (
            <RowButton to="/settings/plan">
              <Icon icon="none" />
              <Text>{t('sidebar.upgrade')}</Text>
            </RowButton>
          )}

          <RowButton bottom onClick={logout}>
            <Icon icon="none" />
            <Text>{t('auth.logout')}</Text>
          </RowButton>

          <CrashButton />
        </div>
      </Overlay>
    )
  }
)({
  label: 'AccountMenu',
  background: 'white',
  borderBottom: border
})

// UserMenu.propTypes = {
//   item: PropTypes.object.isRequired
// }

export default UserMenu
